import { RowModalSidebarType } from '@baserow/modules/database/rowModalSidebarTypes'

import ComentariosSidebar from '@comentarios_mg/components/ComentariosSidebar.vue'

export class ComentariosMGRowModalSidebarType extends RowModalSidebarType {
  static getType() {
    return 'comentarios_mg'
  }

  getName() {
    return 'Comentarios'
  }

  getComponent() {
    return ComentariosSidebar
  }

  isDeactivated(database, table, readOnly, view) {
    // Quien puede abrir la fila puede ver sus comentarios. El backend vuelve a
    // comprobarlo en cada peticion, esto solo decide si se pinta la pestana.
    return false
  }

  isSelectedByDefault(database) {
    return false
  }

  getOrder() {
    // Por delante de "Historia" (10), que es donde estaba la pestana premium.
    return 5
  }
}
